import { render, staticRenderFns } from "./referential-sales-account.vue?vue&type=template&id=174121f7&"
import script from "./referential-sales-account.vue?vue&type=script&lang=ts&"
export * from "./referential-sales-account.vue?vue&type=script&lang=ts&"
import style0 from "./referential-sales-account.vue?vue&type=style&index=0&id=174121f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports